import type { GeoZone } from "../types";

export const initialGeoZones: GeoZone[] = [
  {
    id: "zone-001",
    name: "Greater Hyderabad — demo",
    notes: "Example zone covering two full districts. Add mandals or villages below for finer splits.",
    districtKeys: ["hyderabad", "rangareddy"],
    mandalRefs: [],
    villageRefs: [],
    sortOrder: 0,
    createdAt: new Date().toISOString(),
  },
];
